import MVPBanner from './MVPBanner';
export default MVPBanner;
